import { preloadTimePanelData, toggleConflictsView } from '../actions/publicActions';
import { getStackLength, getTopOfCalendarViewStack } from '../selectors/timePanelStoreSelectors';
import { userDate } from 'owa-datetime';
import { DayGridScenario, initializeDayView, resetDayGridScenario } from 'owa-day-grid';
import { orchestrator } from 'satcheljs';
import {
    initializePanelTelemetryData,
    loadPanel,
    panelClosed,
    panelLoaded,
    pushNewView,
    popView,
    updateSelectedCalendarEvent,
} from '../actions/timePanelStoreActions';

export const loadPanelOrchestrator = orchestrator(loadPanel, async actionMessage => {
    initializePanelTelemetryData();
    panelLoaded(actionMessage.source);
});

export const panelClosedOrchestrator = orchestrator(panelClosed, () => {
    while (getStackLength() > 1) {
        popView();
    }
});

export const preloadTimePanelDataOrchestrator = orchestrator(preloadTimePanelData, async () => {
    await loadPanelData();
});

orchestrator(toggleConflictsView, ({ meeting }) => {
    if (getTopOfCalendarViewStack() == 'Conflicts') {
        popView();
        return;
    }
    pushNewView('Conflicts');
    initializeDayView(
        DayGridScenario.ConflictsView,
        userDate(meeting.Start),
        userDate(meeting.Start)
    );
    updateSelectedCalendarEvent({ ...meeting.AssociatedCalendarItemId, mailboxInfo: null });
});

orchestrator(popView, () => {
    if (getTopOfCalendarViewStack() == 'Conflicts') {
        resetDayGridScenario(DayGridScenario.ConflictsView);
    }
});

async function loadPanelData() {
    // VSO 46502: any prefetch we can do to pre-load agenda view data should be done here, including calling pre-fetch functions from mogenda
}
